app.factory("checkUser", [
  "$localStorage",
  "config",
  "$q",
  "$location",
  "$window",
  "$http",
  "LocalStorageFactory",
  "FiveStreamApiFactory",
  "$rootScope",
  "$route",
  function (
    $localStorage,
    config,
    $q,
    $location,
    $window,
    $http,
    LocalStorageFactory,
    FiveStreamApiFactory,
    $rootScope,
    $route
  ) {
    let doubleLoginCounter = 0;

    var user;
    var loggedIn;
    function getBucketUuids(bucket, bucketName, siteConfig) {
      let q = $q.defer();
      let fnum = "DP-" + $localStorage.shopUserID;
      if (!$localStorage.shopUserID) {
        q.reject("No userId");
      } else {
        try {
          bucket.getObject(
            {
              Bucket: bucketName,
              Key: fnum,
            },
            function (err, data) {
              if (err) {
                q.reject("failed get bucket err");
              } else {
                try {
                  let uuids = JSON.parse(data.Body.toString("ascii"));
                  if (
                    !Array.isArray(uuids) ||
                    uuids.length != siteConfig.concurrentUsers
                  ) {
                    q.reject("failed json parse. Not array or wrong length");
                  } else {
                    q.resolve(uuids);
                  }
                } catch (error) {
                  q.reject("failed json parse");
                }
              }
            }
          );
        } catch (error) {
          q.reject("failed get bucket catch");
        }
      }
      return q.promise;
    }

    function putBucketUuids(bucket, uuids) {
      if ($localStorage.shopUserID) {
        var params = {
          Key: "DP-" + $localStorage.shopUserID,
          Body: uuids,
          CacheControl: "no-cache",
        };
        bucket.putObject(params, function (err, data) {
          if (err) {
            //Raven.captureException(err);
          } else {
          }
        });
      }
    }

    function initAws(region, poolId) {
      var params = {
        IdentityPoolId: poolId,
      };

      AWS.config.region = region; //region
      AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);

      return AWS.config.credentials;
    }

    function awsBucket(bucketName, region) {
      return new AWS.S3({
        params: {
          Bucket: bucketName,
          region: region,
          ACL: "public-read",
        },
      });
    }

    function setUser({
      userId,
      joined,
      name,
      email,
      surname,
      forcePasswordChange,
    }) {
      if (userId) {
        loggedIn = true;
        user = {
          userId,
          joined,
          email,
          name,
          surname,
          forcePasswordChange: forcePasswordChange === "0",
        };

        $localStorage.shopUserID = userId;
        $localStorage.joined = joined;
        $localStorage.email = email;
        $localStorage.name = name;
        $localStorage.surname = surname;
        $localStorage.forcePasswordChange = forcePasswordChange === "0";
      }
    }

    function getUser() {
      if (user) {
        return user;
      }

      let localUser = {
        userId: $localStorage.shopUserID,
        joined: $localStorage.joined,
        email: $localStorage.email,
        name: $localStorage.name,
        surname: $localStorage.surname,
        forcePasswordChange: $localStorage.forcePasswordChange,
      };
      if (localUser.userId) {
        user = localUser;
      }
      return user;
    }

    function checkLogin(callback, error) {
      if (!getUser()) {
        loggedIn = false;
        if (error) {
          error();
        }
        return;
      }
      if (!Object.prototype.hasOwnProperty.call(user, "userId")) {
        loggedIn = false;
        if (error) {
          error();
        }
        return;
      }
      FiveStreamApiFactory.verifyCustomer().then(
        function () {
          loggedIn = true;
          if (callback) {
            callback();
          }
        },
        function () {
          loggedIn = false;
          if (error) {
            error();
          }
        }
      );
    }

    function logOutUser() {
      FiveStreamApiFactory.logoutCustomer()
        .then(() => {
          user = null;
          loggedIn = false;
          $rootScope.accessItems = [];
        })
        .finally(() => {
          localStorage.clear();
          user = null;
          loggedIn = false;
          $rootScope.accessItems = [];
          try {
            LocalStorageFactory.remove("shopUserID");
            LocalStorageFactory.remove("surname");
            LocalStorageFactory.remove("name");
            LocalStorageFactory.remove("email");
            LocalStorageFactory.remove("shopUserID");
            LocalStorageFactory.remove("forcePasswordChange");
            LocalStorageFactory.remove("uuid");
          } catch (err) {}
        });
    }

    return {
      checkGDPR: function (scope) {
        var name = "cookieControl" + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
      setBucketUuids: function (localUuid) {
        let microsite = JSON.parse($localStorage.microsite);
        let siteConfig = microsite.microsite;
        var bucketName = siteConfig.bucketName;
        const region = siteConfig.awsRegion;
        let AwsConfig = initAws(region, siteConfig.identityPoolID);

        AwsConfig.get(function (err) {
          if (err) {
            console.log(" ----------  : " + err);
            return;
          }

          const bucket = awsBucket(bucketName, region);

          //   let uuids = "00000000-0000-0000-0000-000000000000";
          getBucketUuids(bucket, bucketName, siteConfig).then(
            function (quuids) {
              uuids = quuids;
              oldestIndex = 0;
              for (let i = 1; i < uuids.length; i++) {
                if (uuids[oldestIndex].timestamp > uuids[i].timestamp) {
                  oldestIndex = i;
                }
              }
              uuids[oldestIndex].id = localUuid;
              uuids[oldestIndex].timestamp = Math.round(
                new Date().getTime() / 1000
              );
              uuids = JSON.stringify(uuids);

              putBucketUuids(bucket, uuids);
              $localStorage.uuid = localUuid;
            },
            function (failed) {
              newUuids = [];
              newUuids.push({
                id: localUuid,
                timestamp: Math.round(new Date().getTime() / 1000),
              });
              for (let i = 0; i < siteConfig.concurrentUsers - 1; i++) {
                newUuids.push({
                  id: "00000000-0000-0000-0000-000000000000",
                  timestamp: "0",
                });
              }
              uuids = JSON.stringify(newUuids);
              putBucketUuids(bucket, uuids);
              $localStorage.uuid = localUuid;
            }
          );
        });
      },
      checkDoubleLogin: function () {
        let siteConfig = config.fullSite;
        var bucketName = siteConfig.bucketName;
        const region = siteConfig.awsRegion;

        let AwsConfig = initAws(region, siteConfig.identityPoolID);
        AwsConfig.get(function (err) {
          if (err) {
          }

          const bucket = awsBucket(bucketName, region);

          getBucketUuids(bucket, bucketName, siteConfig).then(
            function (quuids) {
              uuids = quuids;
              let failedFlag = true;
              for (let i = 0; i < uuids.length; i++) {
                // does our uuid match the uuids stored in the cloud
                if (uuids[i].id == $localStorage.uuid) {
                  failedFlag = false;
                  doubleLoginCounter = 0;
                  break;
                }
              }
              if (failedFlag) {
                if (doubleLoginCounter > 2) {
                  doubleLoginCounter = 0;
                  logOutUser();
                  if (siteConfig.customErrorMessage !== "--") {
                    LocalStorageFactory.remove("shopUserID");
                    $location.path("/customError");
                  } else {
                    $localStorage.$reset();
                    toastr.error(
                      "too many users logged in, terminating session."
                    );

                    $location.path("/home");
                  }
                } else {
                  doubleLoginCounter = doubleLoginCounter + 1;
                }
              }
            },
            function (failed) {}
          );
        });
      },
      getUUID: function () {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return (
          s4() +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          s4() +
          s4()
        );
      },
      checkLogin: function () {
        if ($localStorage.shopUserID === undefined) {
          loggedIn = false;
          return false;
        } else if (
          $localStorage.shopUserID &&
          ($localStorage.forcePasswordChange === undefined ||
            $localStorage.forcePasswordChange === true)
        ) {
          loggedIn = false;
          // console.log($location.path());
          let currentPath = $location.path();
          if (
            currentPath !== "/forgotPassword" &&
            currentPath !== "/tokenReset" &&
            !currentPath.includes("tokenReset") &&
            currentPath !== "/home" &&
            currentPath !== "/faq" &&
            currentPath !== "/register" &&
            currentPath !== "/login"
          ) {
            $location.path("/forgotPassword");
          }
        } else {
          return true;
        }
      },
      checkLoginAndVerify: function (
        successCallback = () => {},
        failureCallback = () => {}
      ) {
        if (this.checkLogin()) {
          FiveStreamApiFactory.verifyCustomer().then(
            () => {
              successCallback();
            },
            () => {
              failureCallback();
            }
          );
        } else {
          failureCallback();
        }
      },
      setUser: function ({
        userId,
        joined,
        name,
        surname,
        email,
        forcePasswordChange,
      }) {
        if (userId) {
          setUser({
            userId,
            joined,
            name,
            surname,
            email,
            forcePasswordChange,
          });
        }
      },
      getUser: function () {
        return getUser();
      },
      isLoggedIn: function () {
        if (!loggedIn) {
          return false;
        }
        return true;
      },
      verifyLogin(callback, error) {
        checkLogin(callback, error);
      },
      logoutUser() {
        logOutUser();
      },
    };
  },
]);
